import { FaRegHandPointer } from "react-icons/fa";

export const PriPPLWise = ({
  icon,
  alt,
  title,
  total,
  items = [],
  color,
  darkcolor,
  onItemClick,
}) => {
  const hasIcon = Boolean(icon);

  return (
    <div
      className={`${color} rounded-md grid ${
        hasIcon ? "grid-cols-[0.3fr_1fr] items-center" : "grid-cols-1"
      } p-3`}
    >
      {hasIcon && (
        <div
          className={`${darkcolor} rounded-full w-12 h-12 flex justify-center items-center`}
        >
          <img src={icon} alt={alt} className="w-8 h-8" />
        </div>
      )}

      <section className="text-sm font-medium">
        <div className="flex justify-between font-bold">
          <p>{title}</p>
          <p className={`${darkcolor} px-1 rounded-md`}>{total}</p>
        </div>

        {items.map((item, index) => (
          <div key={index} className="flex justify-between">
            <p
              className="cursor-pointer text-gray-600 underline flex items-center gap-1"
              onClick={() => onItemClick(item.label)}
            >
              <FaRegHandPointer className="text-xs text-gray-400" />
              {item.label}
            </p>
            <p>{item.value}</p>
          </div>
        ))}
      </section>
    </div>
  );
};
